export const token = () => {
	return sessionStorage.getItem('token');
}

export const logout = () => {
	sessionStorage.clear();
	localStorage.clear();
}